module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8AXYX"))).then(() => parcelRequire('8rm4T'));